const timelines = document.getElementsByClassName('timeline__wrapper')
const timelineNodes = Array.from(timelines)

if (timelineNodes.length > 0 && window.innerWidth > 1100)
    timelineNodes.forEach((t, index) => {
        const groups = Array.from(t.getElementsByClassName('timeline__group'))

        groups.forEach((g) => {
            const multiplier = 1.0 / groups.length
            g.style.flexBasis = 'calc(100% *' + multiplier + ')'
        })
    })
